import React from 'react';

// Reactively tracks whether the viewport is at or below a width breakpoint. Used to drive
// mobile adaptations that can't be expressed in CSS alone — e.g. collapsing the header links
// into a "More" menu, or shrinking a section's inline styleProps rail so a single card can
// use the full width. Mirrors the 700px breakpoint the storefront CSS already uses.
export const useIsNarrow = (maxWidth = 700): boolean => {
    const query = `(max-width: ${maxWidth}px)`;
    const [narrow, setNarrow] = React.useState<boolean>(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches
    );
    React.useEffect(() => {
        const mq = window.matchMedia(query);
        const onChange = (e: MediaQueryListEvent) => setNarrow(e.matches);
        setNarrow(mq.matches);
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, [query]);
    return narrow;
};
